var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secondary"},[_vm._v(" "+_vm._s(_vm.abbr)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }